import { render, staticRenderFns } from "./AppEnvironmentSwitch.vue?vue&type=template&id=3aea867c"
import script from "./AppEnvironmentSwitch.vue?vue&type=script&lang=js"
export * from "./AppEnvironmentSwitch.vue?vue&type=script&lang=js"
import style0 from "./AppEnvironmentSwitch.vue?vue&type=style&index=0&id=3aea867c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports